import { sitePhrasing } from "../../../Language/languageHandler";
import CheckboxInputField from "../../FormFields/CheckboxInputField/CheckboxInputField";
import { StateSpecificAnnualTerms } from "./AnnualReportStateForms/StateSpecificAnnualTerms";
import { fictitiousNameAgreement, iAmAuthorizedFict, tellingTruthFict } from "./FictitiousNameRenewalFields";
import { einTaxIdAgreement, generalAgreementText, iAgreeText, laborLawPosterAgreementText, legalNoticeAdvertisementAgreement, mayBeContactedAgreementText, stateTransactionAcknowledgmentText } from "./PurchaseConstants";
import { isAnnualSelected } from "./PurchaseFormHelpers";
import { TermsAndConditionAcceptText } from "./SharedPurchaseFieldComponents";

export default function TermsAndConditionsFields(props: {
    errors: any,
    touched: any,
    values: any,
    selectedProducts: any,
    setFieldValue: any
}) {

    const {
        values,
        errors,
        touched,
        selectedProducts = {},
        setFieldValue
    } = props

    const annualSelected = isAnnualSelected(selectedProducts);
    const pastDueAnnualSelected = selectedProducts['pastDueAnnualReport']

    let isGeneralPurchase = true;

    if (
        annualSelected ||
        selectedProducts["einTaxId"] ||
        selectedProducts["legalNoticeAdvertisement"] ||
        selectedProducts["fictitiousNameRenewal"] ||
        selectedProducts["boiReport"] ||
        pastDueAnnualSelected
    ) {
        isGeneralPurchase = false;
    }

    let mayBeContacted = false
    if (
        selectedProducts["einTaxId"] ||
        selectedProducts["fictitiousNameRenewal"]
    ) {
        mayBeContacted = true
    }


    if (annualSelected || pastDueAnnualSelected) {
        mayBeContacted = false
    }

    return (
        <>
            <div className="terms-and-conditions-container">

                {isGeneralPurchase && (<>
                    {generalAgreementText}
                    <br /><br />
                </>)}


                {(annualSelected || pastDueAnnualSelected) && (
                    <>
                        <StateSpecificAnnualTerms state={sitePhrasing.state} />
                        <br /><br />
                    </>
                )}


                {mayBeContacted && (
                    <>
                        {mayBeContactedAgreementText}
                        <br /><br />
                    </>
                )}

                {selectedProducts["einTaxId"] && (
                    <>
                        {einTaxIdAgreement}
                        <br /><br />
                    </>
                )}

                {selectedProducts["fictitiousNameRenewal"] && (
                    <>
                        {fictitiousNameAgreement}
                        <br /><br />
                        {tellingTruthFict}
                        <br /><br />
                        {iAmAuthorizedFict}
                        <br /><br />
                    </>
                )}

                {selectedProducts["legalNoticeAdvertisement"] && (
                    <>
                        {legalNoticeAdvertisementAgreement}
                        <br /><br />
                    </>
                )}

                {iAgreeText}
                <br /><br />

                {selectedProducts["laborLawPoster"] && (
                    <>
                        {laborLawPosterAgreementText}
                        <br /><br />
                    </>
                )}

                {stateTransactionAcknowledgmentText}
                <br /><br />

                <TermsAndConditionAcceptText />

            </div>

            <CheckboxInputField
                fieldName={'termAndConditionAgree'}
                fieldLabel={`I've read and accept the terms and conditions.`}
                touched={touched}
                errors={errors}
                onChange={(e: any) => {
                    const checkedVal = e.target.checked ? true : false;
                    setFieldValue('termAndConditionAgree', checkedVal)
                }}
            />
        </>
    )
}